'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.allowedProperties = exports.propTypes = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _AppBar = require('material-ui/AppBar');

var _AppBar2 = _interopRequireDefault(_AppBar);

var _WMThemeProvider = require('../common/WMThemeProvider');

var _WMThemeProvider2 = _interopRequireDefault(_WMThemeProvider);

var _PropertyHelper = require('../common/PropertyHelper');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = exports.propTypes = {
	children: _propTypes2.default.node,
	iconElementLeft: _propTypes2.default.element,
	iconElementRight: _propTypes2.default.element,
	iconStyleLeft: _propTypes2.default.object,
	iconStyleRight: _propTypes2.default.object,
	onLeftIconButtonClick: _propTypes2.default.func,
	onRightIconButtonClick: _propTypes2.default.func,
	onTitleClick: _propTypes2.default.func,
	showMenuIconButton: _propTypes2.default.bool,
	style: _propTypes2.default.object,
	title: _propTypes2.default.node,
	zDepth: _propTypes2.default.oneOf([0, 1, 2, 3, 4, 5])
};

var allowedProperties = exports.allowedProperties = Object.keys(propTypes);

var WMAppBar = function WMAppBar(props) {
	return _react2.default.createElement(
		_WMThemeProvider2.default,
		null,
		_react2.default.createElement(_AppBar2.default, (0, _PropertyHelper.filter)(props, allowedProperties))
	);
};

exports.default = WMAppBar;


// WEBPACK FOOTER //
// ./~/@workmarket/front-end-components/dist/WMAppBar/index.js